// The one place a list-row chip tone becomes colours. A table, not a ternary chain: every tone names
// its own three CSS custom properties, so adding a tone is one row here and one row in the theme
// bridge rather than three nested conditionals that must all be edited in step.
import type { EntityBoardListPropertyTone } from '../../context/entity.board.list';

/** Resolved chip colours. The values are `var(--local-list-row-property-*)` references, not literals. */
export interface ListRowPropertyToneStyle {
  readonly color: string;
  readonly backgroundColor: string;
  readonly borderColor: string;
}

const TONE_STYLES: Readonly<Record<EntityBoardListPropertyTone, ListRowPropertyToneStyle>> = {
  neutral: {
    color: 'var(--local-list-row-property-text)',
    backgroundColor: 'var(--local-list-row-property-bg)',
    borderColor: 'var(--local-list-row-property-border)',
  },
  muted: {
    color: 'var(--local-list-row-property-text)',
    backgroundColor: 'var(--local-list-row-property-muted-bg)',
    borderColor: 'var(--local-list-row-property-muted-border)',
  },
  success: {
    color: 'var(--local-list-row-property-success)',
    backgroundColor: 'var(--local-list-row-property-success-bg)',
    borderColor: 'var(--local-list-row-property-success)',
  },
  brand: {
    color: 'var(--local-list-row-property-brand)',
    backgroundColor: 'var(--local-list-row-property-brand-bg)',
    borderColor: 'var(--local-list-row-property-brand-border)',
  },
  warning: {
    color: 'var(--local-list-row-property-warning)',
    backgroundColor: 'var(--local-list-row-property-warning-bg)',
    borderColor: 'var(--local-list-row-property-warning-border)',
  },
  error: {
    color: 'var(--local-list-row-property-error)',
    backgroundColor: 'var(--local-list-row-property-error-bg)',
    borderColor: 'var(--local-list-row-property-error-border)',
  },
};

/**
 * Colours for one chip. `disabled` overrides the tone's foreground only — a disabled chip keeps its
 * tone's ground so it still reads as the same kind of chip, just inactive.
 */
export function listRowPropertyToneStyle(tone: EntityBoardListPropertyTone | undefined, disabled?: boolean): ListRowPropertyToneStyle {

  const style = TONE_STYLES[tone ?? 'neutral'] ?? TONE_STYLES.neutral;
  return disabled ? { ...style, color: 'var(--local-list-row-property-disabled)' } : style;
}
